document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function (e) {

        const link = e.target.closest('.blogTagsList li');

        if (!link) return;

        e.preventDefault();

        document.querySelectorAll('.blogTagsList li').forEach(item => {
            item.classList.remove('active');
        });

        link.classList.add('active');

        const selectedTag = link.textContent
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '');

        document.querySelectorAll('.bls__blog-posts-item').forEach(post => {

            const tags = (post.getAttribute('data-tag') || '')
                .toLowerCase()
                .replace(/\s+/g, '');

            if (tags.includes(selectedTag)) {
                post.style.display = '';
            } else {
                post.style.display = 'none';
            }

        });

    });


    // vendor detail page js 
     setTimeout(function () {
        const params = new URLSearchParams(window.location.search);
        const vendor = params.get('vendor');

        if (vendor) {
            const vendorTitle = vendor
                .replace(/-/g, ' ')
                .replace(/\b\w/g, function (match) {
                    return match.toUpperCase();
                });

            $('.breadcrumb-title').text(vendorTitle);
        }
    }, 100);
    
});